export const damageClaimsCompany = [
  {value: 'claims12', label: 'Menej ako rokom'},
  {value: 'claims24', label: 'Viac ako rokom'},
  {value: 'claims36', label: 'Viac ako 2 rokmi'},
  {value: 'claims48', label: 'Viac ako 3 rokmi'},
  {value: 'claims60', label: 'Viac ako 4 rokmi'},
  {value: 'claims72', label: 'Viac ako 5 rokmi'},
  {value: 'claims84', label: 'Viac ako 6 rokmi'},
  {value: 'claims96', label: 'Viac ako 7 rokmi'},
  {value: 'claims108', label: 'Viac ako 8 rokmi'},
  {value: 'claims120', label: 'Viac ako 9 rokmi'},
]

export const damageClaimsPrivate = damageClaimsCompany
